(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"));
	else if(typeof define === 'function' && define.amd)
		define("FGXSdk", ["axios"], factory);
	else if(typeof exports === 'object')
		exports["FGXSdk"] = factory(require("axios"));
	else
		root["FGXSdk"] = factory(root["axios"]);
})(global, function(__WEBPACK_EXTERNAL_MODULE__30__) {
return 